import { ReactNode, useContext } from 'react';

import Message from 'types/Message';
import { Classes } from 'types/Classes';
import { ProductContext } from '@providers/ProductProvider';
import RenderInViewSection from '@templates/RenderInViewSection';
import { SectionId, sections } from '@pages/Product/Product.consts';

type Props = {
  anchor: SectionId;
  title: Message;
  classes?: Classes<'root' | 'header' | 'title'>;
  children: ReactNode;
};

const ProductSection = ({ anchor, title, classes, children }: Props) => {
  const { anchorIndex } = useContext(ProductContext);
  const isActiveSection = sections.indexOf(anchor) <= anchorIndex;

  return (
    <div anchor-id={anchor}>
      <RenderInViewSection title={title} classes={classes} forceShow={isActiveSection}>
        {children}
      </RenderInViewSection>
    </div>
  );
};

export default ProductSection;
